import { Listbox, Transition } from "@headlessui/react"
import React, { Fragment, useState } from "react";

export interface DropdownItem {
    name: string,
    [x: string]: any
}

interface IProps {
    title?: string,
    dataSource: Array<DropdownItem>,
    selected: DropdownItem,
    placeholder?: string,
    errMsg?: string,
    onChange: (selected: DropdownItem) => void
}

export default function Dropdown(props: IProps) {
    const [selected, setSelected] = useState<DropdownItem>(props.selected)

    const isEmpty = !selected.name.length
    return (
        <div className="w-full flex flex-col space-y-1">
            <p className={"text-sm font-medium text-black leading-5"}>{props.title}</p>
            <Listbox value={selected} onChange={(value) => {
                setSelected(value)
                props.onChange(value)
            }}>
                <div className="relative mt-1">
                    <Listbox.Button className={`relative w-full text-left px-2 py-2.5 text-base ${!isEmpty ? "text-black" : "text-[#B0B1B2]"} rounded-lg border ${props.errMsg && props.errMsg.length ? "border-error" : "border-[#8698C0]"} transition ease-in-out`}>
                        <span className="block truncate">{!isEmpty ? selected.name : props.placeholder}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.47396 4.51844C2.64441 4.34457 2.91114 4.32877 3.09909 4.47102L3.15294 4.51844L7.00001 8.44283L10.8471 4.51844C11.0175 4.34457 11.2843 4.32877 11.4722 4.47102L11.5261 4.51844C11.6965 4.69231 11.712 4.96438 11.5725 5.15611L11.5261 5.21104L7.3395 9.48156C7.16905 9.65543 6.90232 9.67123 6.71437 9.52898L6.66052 9.48156L2.47396 5.21104C2.28647 5.01978 2.28647 4.7097 2.47396 4.51844Z" fill="#8698C0"/>
                            </svg>
                        </span>
                    </Listbox.Button>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Listbox.Options className="z-20 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {props.dataSource.map((item, idx) => {
                                if (item.name.length === 0) {
                                    return null
                                }
                                return (
                                    <Listbox.Option
                                        key={idx}
                                        className={({ active }) =>
                                            `relative cursor-default select-none py-2 pl-9 pr-4 ${
                                                active ? "bg-[#EEF3F9] text-primary" : "text-black"
                                            }`
                                        }
                                        value={item}
                                    >
                                        {({ selected }) => (
                                            <>
                                                <span
                                                    className={`block truncate ${
                                                        selected ? "font-medium" : "font-normal"
                                                    }`}
                                                >
                                                    {item.name}
                                                </span>
                                                {selected ? (
                                                    <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-amber-600">
                                                        <div className="h-5 w-5">
                                                            <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 24L20 34L40 14" stroke="#365496" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                        </div>
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                )
                            })}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
            {props.errMsg && props.errMsg.length ? <p className={"text-sm italic text-error"}>{props.errMsg}</p> : null}
        </div>
    )
}
